import { cn, cx, tv, type VariantProps } from "tailwind-variants";

const spinnerVariants = tv({
	defaultVariants: {
		size: "md",
		intent: "primary",
		placement: "center",
		width: "full",
	},
	variants: {
		intent: {
			danger: ["text-danger"],
			dark: ["text-dark"],
			info: ["text-info"],
			light: ["text-light"],
			primary: ["text-primary"],
			secondary: ["text-secondary"],
			success: ["text-success"],
			warning: ["text-warning"],
		},
		placement: {
			bottom: ["justify-end"],
			center: ["justify-center"],
			left: ["justify-start"],
			right: ["justify-end"],
			top: ["justify-start"],
		},
		size: {
			xl: ["size-12"],
			lg: ["size-10"],
			md: ["size-8"],
			sm: ["size-6"],
			xs: ["size-4"],
		},
		width: {
			full: "w-full",
		},
		variant: {
			border: ["spinner-border"],
			grow: ["spinner-grow"],
		},
	},
});

export type SpinnerProps = VariantProps<typeof spinnerVariants>;

export default function Spinner({
	placement,
	size,
	variant,
	intent,
	width,
}: SpinnerProps) {
	return (
		<div
			className={cn(
				"flex flex-col my-6",
				spinnerVariants({ placement: placement ?? "center", width: width }),
			)}
		>
			<div>
				<span className="sr-only">Loading...</span>
				<svg
					aria-label={"Loading..."}
					className={cx(
						spinnerVariants({
							intent: intent,
							size: size,
							variant: variant ?? "border",
						}),
						"animate-spin",
					)}
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
				>
					<circle
						className="opacity-25"
						cx="12"
						cy="12"
						r="10"
						stroke="currentColor"
						stroke-width="4"
					></circle>
					<path
						className="opacity-75"
						fill="currentColor"
						d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					></path>
				</svg>
			</div>
		</div>
	);
}
